import { Divider } from "@crm/ui/components/auth/divider";
import { ErrorAlert } from "@crm/ui/components/auth/error-alert";
import { OtpForm } from "@crm/ui/components/auth/otp-form";
import { useOtpLogin } from "@crm/ui/hooks/use-otp-login";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/login")({
  head: () => ({
  }),
  component: LoginPage,
});

function LoginPage() {
  const {
    otpEmail,
    otp,
    otpSent,
    isSendingOtp,
    isVerifyingOtp,
    otpError,
    cooldownExpiry,
    setOtpEmail,
    setOtp,
    handleSendOtp,
    handleVerifyOtp,
    handleResendOtp,
  } = useOtpLogin();

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-sm">
        <div className="mb-8 text-center">
          <h1 className="font-bold text-2xl text-gray-900">imiker 学员工作台</h1>
          <p className="mt-2 text-gray-500 text-sm">使用邮箱验证码登录</p>
        </div>

        {otpError ? <ErrorAlert message={otpError} /> : null}

        <OtpForm
          cooldownExpiry={cooldownExpiry}
          isSendingOtp={isSendingOtp}
          isVerifyingOtp={isVerifyingOtp}
          onEmailChange={setOtpEmail}
          onOtpChange={setOtp}
          onResend={handleResendOtp}
          onSendOtp={handleSendOtp}
          onVerifyOtp={handleVerifyOtp}
          otp={otp}
          otpEmail={otpEmail}
          otpError={otpError}
          otpSent={otpSent}
        />

        <Divider text="使用与 CRM 相同的账号" />
      </div>
    </div>
  );
}
